<template>
  <div>
    <!-- pop up success -->
    <transition name="fade">
      <div class="position-relative" style="z-index: 1034">
        <div class="row no-gutters justify-content-center">
          <div class="fixed-bottom d-block nav-bottom" style="bottom:45%">
            <div class="custom-container-fluid px-0">
              <div class="row justify-content-center no-gutters">
                <div class="col-xl-4 col-lg-4 col-md-6 col-sm-8 col-12 position-relative">
                  <div class="bg-white mx-5 rounded-4">
                    <div class="w-100 py-3 px-2">
                      <div class="container px-4 text-center position-relative">
                        <router-link :to="'/'+getMerchant().code+'/concierge?reload=1'">
                          <img src="../../../../assets/img/icon/close.png" class="m-2 position-absolute" width="16" style="right: 0;top: -10px;">
                        </router-link>
                        <div class="rounded-100 my-2 w-20 mx-auto">
                          <div class="bg-green rounded-100 mx-auto size-icon-in">
                            <img src="../../../../assets/img/icon/correct-white.png" width="40" style="margin: 20px 20px">
                          </div>
                        </div>
                        <div class="pb-3">
                          <p class="mb-0 body-2-2 text-20 text-green font-extrabold">{{$t('hotel.concierge.request-maintenance-success')}}</p>
                          <router-link :to="'/'+getMerchant().code+'/concierge/order?reload=1'">
                            <button type="button" class="button-primary text-green bg-white py-2 px-3 text-12 mt-3">{{$t('hotel.concierge.order-history')}}</button>
                          </router-link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
  import {mapGetters} from 'vuex';

  export default{
    components: {
    },
    data() {
      return {
        
      }
    },
    methods: {
      ...mapGetters(['getMerchant']),
      updateScroll() {
        this.scrollPosition = window.scrollY
      },
    },
  }
</script>


// WEBPACK FOOTER //
// src/components/hotel/concierge/general/popUpSuccessRequest.vue